import { render, staticRenderFns } from "./TheNewUserDialog.vue?vue&type=template&id=395302b6&scoped=true&"
import script from "./TheNewUserDialog.vue?vue&type=script&lang=js&"
export * from "./TheNewUserDialog.vue?vue&type=script&lang=js&"
import style0 from "./TheNewUserDialog.vue?vue&type=style&index=0&id=395302b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395302b6",
  null
  
)

export default component.exports